(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('AppAttestLog', AppAttestLog);

    AppAttestLog.$inject = ['$resource', 'DateUtils'];

    function AppAttestLog ($resource, DateUtils) {
        var resourceUrl =  'api/app-attest-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
